import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { axiosc } from 'src/app/utils';
import { DrawenLayerGroupTarafResultType } from 'src/types/components/draw-module.type';

export const getAllGroupsTaraf = (): AxiosPromise<DrawenLayerGroupTarafResultType[]> => {
  return axiosc.get(`${urlsConfig.generics.drawModule.drawenLayerGroupsTaraf}`, {
    blockSpinner: true,
  });
};

export const updatePrivileges = (
  layerId: number,
  targetKeys: any,
  userTarafId: number,
): AxiosPromise<DrawenLayerGroupTarafResultType> => {
  return axiosc.post(
    `${urlsConfig.generics.drawModule.drawenLayerGroupsTaraf}/updatePrivileges/${layerId}`,
    { tarafIds: targetKeys, userTarafId },

    {
      blockErrorHandler: true,
    },
  );
};

export const getOneLayerGroupTaraf = (layerId: number): AxiosPromise<DrawenLayerGroupTarafResultType[]> => {
  return axiosc.get(`${urlsConfig.generics.drawModule.drawenLayerGroupsTaraf}/listDrawenLayerGroupTaraf/${layerId}`, {
    blockSpinner: true,
  });
};

export const destroyDrawenLayerGroupsLayer = (userTarafId: number, id: number, layerId: number): AxiosPromise<any> => {
  return axiosc.delete(`${urlsConfig.generics.drawModule.drawenLayerGroupsLayer}/${userTarafId}/${layerId}/${id}`, {
    blockErrorHandler: true,
  });
};
